module.exports = __webpack_public_path__ + "img/near_cyl75_axis45.476c8b92.jpg";